module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.70b66dfd.png";